import React from "react";
import "./UsuarioModal.css";

export default function UsuarioModal({ novoUsuario, onChange, onSalvar, onFechar }) {
  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onFechar()}
    >
      <div className="modal-content">
        <h2>Adicionar Usuário</h2>
        <form
          onSubmit={(e) => {
            onSalvar(e);
            onFechar();
          }}
        >
          <input type="text" name="nome" placeholder="Nome" value={novoUsuario.nome} onChange={onChange} required />
          <input type="email" name="email" placeholder="Email" value={novoUsuario.email} onChange={onChange} required />
          <input type="text" name="cargo" placeholder="Cargo/Função" value={novoUsuario.cargo} onChange={onChange} />
          <input type="text" name="departamento" placeholder="Departamento" value={novoUsuario.departamento} onChange={onChange} />
          <input type="text" name="nivelAcesso" placeholder="Nível de acesso" value={novoUsuario.nivelAcesso} onChange={onChange} />
          <input type="text" name="matricula" placeholder="Matrícula" value={novoUsuario.matricula} onChange={onChange} />
          <input type="text" name="endereco" placeholder="Endereço" value={novoUsuario.endereco} onChange={onChange} />
          <input type="text" name="cpf" placeholder="CPF" value={novoUsuario.cpf} onChange={onChange} />
          <div className="modal-buttons">
            <button type="submit">Salvar</button>
            <button type="button" onClick={onFechar}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}
